import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
const DealerBalloonPhone = ({ value, className }) => {
  return /* @__PURE__ */ jsx(
    Typography.Paragraph,
    {
      level: "small",
      color: "darkest",
      "data-phone": value,
      className: classnames("perxis-auto-dealer-balloon-phone", className),
      children: value
    }
  );
};
export {
  DealerBalloonPhone as default
};
//# sourceMappingURL=DealerBalloonPhone.js.map
